/* eslint-disable import/no-named-as-default-member */
import i18n from "i18next";
import HttpApi from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { LOG_I18N_WARNINGS } from "./utils/constants";
import { getBrowserLocale } from "./utils/locale";

if (i18n.isInitialized) {
  throw new Error(
    "i18n is already initialized, ensure the session and index i18n are not mixed"
  );
}

i18n
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    lng: getBrowserLocale() ?? "en",

    // enable debug on dev mode
    debug: LOG_I18N_WARNINGS,

    // allowed languages
    supportedLngs: ["en", "id", "th", "vi"],

    // fallback to english if detected language is unavailable
    fallbackLng: "en",

    // disable escaping since React takes care of it
    interpolation: {
      escapeValue: false
    },

    // default namespace if not specified
    defaultNS: "common",

    // do not load any namespace unless required
    ns: [],

    // do not allow `null` as valid translation
    returnNull: false
  });

/**
 * reload resources upon change of locale files without
 * a full page reload
 */
if (import.meta.hot) {
  import.meta.hot.on("locales-update", () => {
    i18n.reloadResources().then(() => {
      i18n.changeLanguage(i18n.language);
    });
  });
}
